import React from 'react';
import { useTranslation } from 'react-i18next';

/**
 * EN ⇄ 中文 switcher. Persists via i18next (localStorage key operis_language).
 */
const LanguageToggle = ({ className = '' }) => {
  const { i18n } = useTranslation();
  const currentLang = (i18n.language || 'en').startsWith('zh') ? 'zh' : 'en';

  const toggleLanguage = () => {
    i18n.changeLanguage(currentLang === 'en' ? 'zh' : 'en');
  };

  const base =
    'relative px-3 py-2 rounded-xl transition-colors bg-gray-100 dark:bg-gray-700/50 text-gray-700 dark:text-gray-200 hover:bg-gray-200 dark:hover:bg-gray-600 text-sm font-semibold';

  return (
    <button
      type="button"
      onClick={toggleLanguage}
      className={className ? `${base} ${className}` : base}
      title={currentLang === 'en' ? '中文' : 'English'}
    >
      {currentLang === 'en' ? 'EN' : '中文'}
    </button>
  );
};

export default LanguageToggle;
